import { Building2, CalendarCheck, ChartColumn, type LucideIcon, Mail, Megaphone, Store } from "lucide-react";
import { m } from "../../paraglide/messages.js";

// The six places of Guestlist (ADR-306, ADR-315 §5): the work of the day, the campaigns, the accounts, the emails, the
// brands and Insights, each with its `g` key. Insights is never the home. Activities come with their screens (P8.14o),
// so no link leads nowhere.

export interface Place {
  to: "/" | "/campaigns" | "/accounts" | "/emails" | "/brands" | "/insights";
  label: () => string;
  icon: LucideIcon;
  /** The letter after `g`. */
  key: string;
  /** Other paths of the same place: the sends are half of Emails (ADR-319). */
  also?: readonly string[];
}

export const PLACES: readonly Place[] = [
  { to: "/", label: m.nav_today, icon: CalendarCheck, key: "t" },
  { to: "/campaigns", label: m.nav_campaigns, icon: Megaphone, key: "c" },
  { to: "/accounts", label: m.nav_accounts, icon: Building2, key: "a" },
  { to: "/emails", label: m.nav_emails, icon: Mail, key: "e", also: ["/sends"] },
  { to: "/brands", label: m.nav_brands, icon: Store, key: "b" },
  { to: "/insights", label: m.nav_insights, icon: ChartColumn, key: "i" },
];
